import React from 'react';
import I18n from 'i18n-js';

import { Listing } from '@reverbdotcom/commons/src/rql';

interface IExternalProps {
  listing: Listing;
}

export default function PublishErrors({ listing }: IExternalProps) {
  const showErrors =
    listing.state === 'draft' && !listing.publishValidation?.isValid;

  if (!showErrors) return null;

  const errors = listing.publishValidation?.errors ?? [];

  return (
    <>
      <div className="text-color-red-500 mt-1 weight-bold">
        {I18n.t('discovery.listingsManagement.sellerListingCard.draftErrors')}
      </div>
      <div className="text-color-red-500 weight-semibold ml-6">
        <ul className="seller-listing-card__errors">
          {errors.map((error) => (
            <li key={error.message}>{error.message}</li>
          ))}
        </ul>
      </div>
    </>
  );
}
